import { ofType } from 'redux-observable';
import { switchMap, map } from 'rxjs/operators';
import { Type } from './redux';

const getPaperInfo = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_PAPER_INFO),
    switchMap(({ paperId, scope }) =>
      fetch({
        url: `/mm-tiku/api/v1/paper/${paperId}`,
        method: 'GET',
        scope,
        body: {
          paperId,
        },
      }),
    ),
    map(({ name }) => ({
      type: Type.GET_PAPER_INFO_SUCCESS,
      name,
    })),
  );

export default [getPaperInfo];
